import { Component } from '@angular/core';
import { environment } from '@environment/environment';

@Component({
  imports: [],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public year: number = new Date().getFullYear();
  public version: string = environment.version;
}
